import React from "react";
import {
    Button,
    CloseIcon,
    Dialog,
    LeaveIcon,
} from "@fluentui/react-northstar";
import useDialog from "../../../../hooks/useDialog";
import styled from "styled-components";
import DialogPrepareOffboardingContent from "./DialogPrepareOffboardingContent";
import usePrepareOffboarding from "../../hooks/usePrepareOffboarding";
import { FormProvider } from "react-hook-form";
import Toast from "../../../../components/Alerts";

const DialogPrepareOffboarding = () => {
    const {
        query_list_users,
        query_list_type_status,
        methods,
        mutation,
        dialog,
    } = usePrepareOffboarding();

    return (
        <>
            <FormProvider {...methods}>
                <form onSubmit={methods.handleSubmit(methods.onSubmit)}>
                    <DialogStyle
                        open={dialog.open}
                        header={"Préparer un Offboarding"}
                        content={
                            <DialogPrepareOffboardingContent
                                list_offboarding_users={
                                    query_list_users.formated_data
                                }
                                list_status_types={
                                    query_list_type_status.formated_data
                                }
                                is_loading_status={
                                    query_list_type_status.isLoading
                                }
                                selected_user={methods.getValues("user_id")}
                            />
                        }
                        confirmButton={{
                            content: "Valider ce statut",
                            loading: mutation.isLoading,
                            flat: true,
                            disabled: !methods.formState.isValid,
                            onClick: () => {
                                return methods.handleSubmit(methods.onSubmit)();
                            },
                        }}
                        cancelButton={{
                            content: "Annuler",
                            flat: true,
                        }}
                        headerAction={{
                            icon: <CloseIcon />,
                            onClick: dialog.beforeCloseDialog,
                        }}
                        onCancel={dialog.beforeCloseDialog}
                        trigger={
                            <Button
                                content={"Préparer un Offboarding"}
                                icon={
                                    <LeaveIcon
                                        outline
                                        styles={{ color: "black" }}
                                    />
                                }
                                iconPosition="after"
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    dialog.openDialog();
                                }}
                                flat
                            />
                        }
                    />
                </form>
            </FormProvider>
        </>
    );
};

export default DialogPrepareOffboarding;

const DialogStyle = styled(Dialog)`
    width: 507px;
    min-height: 448px;
    padding: 28px 32px 32px 32px;
    gap: 8px;

    border-radius: 4px;
    background: var(--Light-theme-Rest-Background-Default-Background, #fff);

    box-shadow: 0px 2.4px 7.4px 0px rgba(0, 0, 0, 0.18),
        0px 12.8px 28.8px 0px rgba(0, 0, 0, 0.22);

    grid-template-rows: 24px 1fr 32px;
`;
